import type { ComponentType } from 'react';
import type { PrintDoc, PrintDocProps } from './print-types';

const registry = new Map<PrintDoc, ComponentType<PrintDocProps<unknown>>>();

/**
 * Lives apart from PrintHost so the document modules can import it without a
 * cycle: PrintHost imports ./docs, and ./docs registers into this.
 */
export function registerPrintDoc<T>(doc: PrintDoc, component: ComponentType<PrintDocProps<T>>): void {
  registry.set(doc, component as unknown as ComponentType<PrintDocProps<unknown>>);
}

export function getPrintDoc(doc: PrintDoc): ComponentType<PrintDocProps<unknown>> | undefined {
  return registry.get(doc);
}

export function hasPrintDoc(doc: PrintDoc): boolean {
  return registry.has(doc);
}

/** For tests that need a document to be missing. */
export function unregisterPrintDoc(doc: PrintDoc): void {
  registry.delete(doc);
}
